import { AnswerType } from 'shared/domain/checklistAnswer/types/answerType';
import { ComplianceAnswerOption } from 'shared/domain/compliance/complianceAnswerOption';
import {
  ChecklistItemAnswerModel,
  ComplianceChecklistAnswerModel,
  NumericChecklistAnswerModel,
  TextChecklistAnswerModel,
  OptionSelectionChecklistAnswerModel,
} from './inspectionTemplateModel';

export function isComplianceChecklistAnswer(
  answer: ChecklistItemAnswerModel
): answer is ComplianceChecklistAnswerModel {
  return answer.type === AnswerType.Compliance;
}

export function isNumericChecklistAnswer(
  answer: ChecklistItemAnswerModel
): answer is NumericChecklistAnswerModel {
  return answer.type === AnswerType.Numeric;
}

export function isTextChecklistAnswer(
  answer: ChecklistItemAnswerModel
): answer is TextChecklistAnswerModel {
  return answer.type === AnswerType.Text;
}

export function isOptionSelectionChecklistAnswer(
  answer: ChecklistItemAnswerModel
): answer is OptionSelectionChecklistAnswerModel {
  return answer.type === AnswerType.OptionSelection;
}

export function getActiveChecklistAnswers(
  answers: ReadonlyArray<ChecklistItemAnswerModel> | undefined
): ChecklistItemAnswerModel[] {
  return (answers ?? []).filter(
    (answer) => !('deleted' in answer && answer.deleted)
  );
}

/** True when the control element includes an active compliance question. */
export function hasComplianceChecklistAnswer(
  answers: ReadonlyArray<ChecklistItemAnswerModel> | undefined
): boolean {
  return getActiveChecklistAnswers(answers).some(isComplianceChecklistAnswer);
}

/** Hide unset status for EK without a compliance question; keep legacy non-unset results. */
export function shouldShowComplianceStatus(
  answers: ReadonlyArray<ChecklistItemAnswerModel> | undefined,
  result: ComplianceAnswerOption
): boolean {
  if (hasComplianceChecklistAnswer(answers)) {
    return true;
  }

  return result !== ComplianceAnswerOption.unset;
}
